import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChildren
} from '@angular/core';
import {ItemEvent} from "../../../ItemEvent";
import {LabelStyleProviderService} from "../../../../services/labelStylesProvider/label-style-provider.service";
import {Item} from "../../../../models/Item";
import {MapObjectPlugin} from "../../MapObjectPlugin";
import {CesiumAdapterService} from "../../../../services/cesiumAdapter21/cesium-adapter.service";
import {BabyAdapterService} from "../babyAdapter/baby-adapter.service";
import {isViewMode} from "../../../../../configs/view_only";
import {UiAdapterService} from "../../../../services/uiAdapterService/ui-adapter.service";
import {Subscription} from "rxjs";
import {WhiteTooltipDirective} from "../../../../directives/whiteTooltip/white-tooltip.directive";
declare const Yiit;
import {associationMap} from '@src/configs/label_styles_config';
import {ItemManagerService} from '@src/app/services/itemManager/item-manager.service';

const $ = window['jQuery'];

@Component({
  selector: 'app-baby-number',
  templateUrl: './baby-number.component.html',
  styleUrls: ['./baby-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BabyNumberComponent implements OnInit, OnDestroy {

  @ViewChildren(WhiteTooltipDirective) tooltips;
  @Input() item:Item;

  public anchors;
  public styles;

  public selectedAnchor;
  public selectedStyle;
  public currentBaby;
  public zoomLevel;
  public Yiit = Yiit;
  protected subscribers: Subscription;

  constructor(
    protected cd: ChangeDetectorRef,
    protected adapter: CesiumAdapterService,
    protected babyAdapter: BabyAdapterService,
    protected uiAdapterService: UiAdapterService,
    protected im: ItemManagerService) {
  }

  ngOnInit() {
    this.subscribers = new Subscription();
    this.subscribers.add(this.uiAdapterService.selectedItem$.subscribe((item)=>{
      this.selectedAnchor = this.babyAdapter.getBabyAnchor(item.getId());
      this.selectedStyle = associationMap.has(this.babyAdapter.getBabyStyle(item.getId())) ? associationMap.get(this.babyAdapter.getBabyStyle(item.getId())) : this.babyAdapter.getBabyStyle(item.getId());
      if (!this.selectedStyle || this.selectedStyle.trim().length === 0){
        this.selectedStyle = associationMap.get('default');
      }
      this.currentBaby = this.babyAdapter.getBabyByItemId(item.getId());
      this.cd.detectChanges();
    }));
    this.currentBaby = this.babyAdapter.getBabyByItemId(this.item.getId());
    this.anchors = this.babyAdapter.anchorList;
    this.subscribers.add(this.babyAdapter.stylesList.subscribe((stylesList)=>{
      this.styles = stylesList;
    }));
    this.selectedAnchor = this.babyAdapter.getBabyAnchor(this.item.getId());
    this.selectedStyle = associationMap.has(this.babyAdapter.getBabyStyle(this.item.getId())) ? associationMap.get(this.babyAdapter.getBabyStyle(this.item.getId())) : this.babyAdapter.getBabyStyle(this.item.getId());
    if (!this.selectedStyle || this.selectedStyle.trim().length === 0){
      this.selectedStyle = associationMap.get('default');
    }

    if ($){
      $(document).on('click'+`.baby-${this.item.getId()}`, function (event) {
        if (
          $(event.target).closest('.es-group-select-container').length == 0
          && $(event.target).closest('.es-baby-number-input').length == 0
        ) {
          $('.es-group-select-container').removeClass('active');
        }
        if (
          !$(event.target).is('.es-item-details-icon')
          && $(event.target).closest('.es-item-details-hide-container').length == 0
        ) {
          $('.es-item-details-icon.active').removeClass('active');
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscribers.unsubscribe();
    if ($) {
      $(document).off(`.baby-${this.item.getId()}`);
    }
    this.tooltips.forEach((_item:WhiteTooltipDirective)=>{
      _item.hide();
    });
    this.cd.detach();
  }


  showBabyNumberParams(){
    document.querySelector('#baby-number-params-' + this.item.getId()).classList.add('active');
  }
  showBabyNumber(event){
    var currentElm = event.currentTarget || event.target,
      input = currentElm.nextSibling;
      input.focus();
  }
  hideBabyNumber(event){
    if (this.item.config.getInputProp('__baby_number', 'value').length > 0) {
      return;
    }
    var currentElm = event.currentTarget || event.target,
      wrapper = currentElm.parentElement;
      wrapper.classList.remove('active');
  }

  selectedStyleChanged(name){
    let item = this.getItemToChange();
    this.babyAdapter.setBabyStyle(item.getId(), associationMap.has(name) ? associationMap.get(name): name);
    this.selectedStyle = name;
  }

  selectedAnchorChanged(name){
    let item = this.getItemToChange();
    this.babyAdapter.setBabyAnchor(item.getId(), name);
    this.selectedAnchor = name;
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }
  validateItemParam(name, prop, event) {
    let item = this.getItemToChange();
    let value: string = event.target.value;
    if (value.length > 100) {
      alert(Yiit.t('You have reached the character limit. Please use less characters and try again.'));
      value = value.substr(0, 100);
      const prevValue = item.config.getInputProp('__baby_number', 'value');
      event.target.value = value;
      this.cd.detectChanges();
      if (value == prevValue) {
        return;
      }
    }
    item.config.setInputValue(name, prop, value);
  }

  private getItemToChange():Item{
    return this.item.config.isCopy ? this.im.getItemById(this.item.config.getCopyParentId) : this.item;
  }
}
